import axios from "axios";
import { host } from "./utilities";

export const listAnnouncementsAxios = () => (config) => axios.get(`${host()}/announcements/list`, config);
